<template>
  <div id="contacts-page">
    <div id="page-header">
      <app-icon
        name="contact"
        size="normal"
        color="#fff" />
    </div>
    <template v-if="entranceConfig.usefulNumbers.length">
      <div
        v-for="(item, index) in contactsPages[pageOnDisplay]"
        :key="index"
        class="contact-item">
        <app-icon
          :name="item.type"
          size="small"
          color="#fff" />
        <div class="contact-details">
          <span
            class="contact-title"
            :class="{ large: item.contact.length > 30 }">
            &#8226; {{ item.title }}
          </span>
          <span
            class="contact-contact"
            :class="{ large: item.contact.length > 30 }">
            {{ item.contact }}
          </span>
        </div>
      </div>
    </template>
    <template v-else>
      <div id="empty-template">
        Auncun contact à afficher
      </div>
    </template>

    <div class="dock">
      <div class="dock-banner">
        <div
          class="dock-item"
          @click="changePage('previous')">
          <app-icon
            name="previous"
            size="small"
            :color="contactsPages.length > 1 ? '#fff' : '#1b1b1b'"/>
        </div>
        <div class="dock-item" @click='resetTimer()'>
          <Waiter
            :relativeProgress='timerRelativeProgress'
            icon="replay"
            color="rgba(255,255,255, 1)" />
        </div>
        <div
          class="dock-item"
          @click="changePage('next')">
          <app-icon
            name="next"
            size="small"
            :color="contactsPages.length > 1 ? '#fff' : '#1b1b1b'"/>
        </div>

        <div class="dock-button">
          <app-icon
            @click="stopConsultation()"
            name="dockHomeButton"
            size="inter"
            color="black"/>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="sass">
#contacts-page
  background: rgba(0,0,0,.65)
  bottom: 0
  display: flex
  flex-direction: column
  left: 0
  padding-bottom: 11rem
  position: absolute
  right: 0
  top: 0
#page-header
  align-items: center
  display: flex
  height: 12rem
  justify-content: center
  width: 100%
#empty-template
  align-items: center
  color: #fff
  display: flex
  justify-content: center
.contact-item
  align-items: center
  display: flex
  height: 9rem
  margin: .5rem .7rem 1rem 2rem
  svg
    border-right: 1px solid #fff
    margin: 0 2.3rem
    padding-right: 2rem
    width: 5rem
  .contact-details
    display: flex
    flex-direction: column
    .contact-title
      color: #c7c7c7
      font-family: 'RobotoLightItalic'
      font-size: 1em
      &.large
        font-size: .7em
    .contact-contact
      color: #fafafa
      font-family: 'RobotoRegular'
      font-size: 1.2em
      &.large
        font-size: .8em
</style>

<script>
import AppIcon from '@/components/icons/AppIcon.vue';
import Waiter from '@/components/appModules/Waiter.vue';

export default {
  name: 'ContactsPage',

  components: {
    AppIcon,
    Waiter,
  },

  props: {
    entranceConfig: Object,
  },

  data() {
    return {
      pageOnDisplay: null,
      TIMER_DURATION: 35000,
      timerStartTime: null,
      timerRelativeProgress: 0,
      timerAnimation: null,
    };
  },

  computed: {
    contactsPages() {
      this.pageOnDisplay = this.pageOnDisplay || 0;
      const pagesList = [];
      let page = [];

      const usefulNumbers = this.entranceConfig.usefulNumbers
        .sort((a, b) => (a.title > b.title) ? 1 : (a.title === b.title) ? ((a.contact > b.contact) ? 1 : -1) : -1);

      for (let i = 0; i < usefulNumbers.length; i++) {
        const element = usefulNumbers[i];
        page.push(element);

        if (page.length === 9 || i === usefulNumbers.length - 1) {
          pagesList.push(page);
          page = [];
        }
      }

      return pagesList;
    },
  },

  activated() {
    this.timerAnimation = requestAnimationFrame(this.animateTimer);
  },

  deactivated() {
    cancelAnimationFrame(this.timerAnimation);
    this.timerAnimation = null;
    this.timerStartTime = null;
    this.timerRelativeProgress = 0;
    this.pageOnDisplay = null;
  },

  methods: {
    changePage(type) {
      const nextPage = this.pageOnDisplay + 1 >= this.contactsPages.length
        ? 0
        : this.pageOnDisplay + 1;
      const previousPage = this.pageOnDisplay - 1 < 0
        ? this.contactsPages.length - 1
        : this.pageOnDisplay - 1;
      this.pageOnDisplay = type === 'previous' ? previousPage : nextPage;
    },

    stopConsultation() {
      this.$router.push({ name: 'home' });
    },

    animateTimer(timestamp) {
      if (!this.timerStartTime) this.timerStartTime = timestamp;

      const runTime = timestamp - this.timerStartTime;
      this.timerRelativeProgress = runTime / this.TIMER_DURATION;

      if (runTime < this.TIMER_DURATION) {
        this.timerAnimation = requestAnimationFrame(this.animateTimer);
      } else {
        cancelAnimationFrame(this.timerAnimation);
        this.timerAnimation = null;
        this.timerStartTime = null;
        this.timerRelativeProgress = 0;
        this.stopConsultation();
      }
    },

    resetTimer() {
      cancelAnimationFrame(this.timerAnimation);
      this.timerAnimation = null;
      this.timerStartTime = null;
      this.timerRelativeProgress = 0;
      this.timerAnimation = requestAnimationFrame(this.animateTimer);
    },
  },

  filters: {
  },
};
</script>
